// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__uIEoR","menu__list":"Menu_menu__list__Whu3Q","menu__link":"Menu_menu__link__JBMgs"};